var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94246 15.3333C1.4383 15.3333 1.0067 15.1538 0.647672 14.7948C0.288645 14.4357 0.109131 14.0041 0.109131 13.5V2.49996C0.109131 1.99579 0.288645 1.5642 0.647672 1.20517C1.0067 0.84614 1.4383 0.666626 1.94246 0.666626H7.44246L9.2758 2.49996H16.6091C17.1133 2.49996 17.5449 2.67947 17.9039 3.0385C18.2629 3.39753 18.4425 3.82913 18.4425 4.33329V13.5C18.4425 14.0041 18.2629 14.4357 17.9039 14.7948C17.5449 15.1538 17.1133 15.3333 16.6091 15.3333H1.94246Z",
    fill: "#EA4903"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectFolderIcon);
export default __webpack_public_path__ + "static/media/object-folder-icon.65f3cd518f4ff9a2ca30f9b8c0709c5f.svg";
export { ForwardRef as ReactComponent };